export default "__VITE_ASSET__Cfj_pMsl__"